export default __webpack_public_path__ + "static/media/video_mobile_thumb.45d42957.png";